var version = '6.1.3';

module.exports = version;
